import { Variables } from '@/services/backstage/config';
import { useLists } from '@/services/lists/ListProvider';
import { useGraph, useGraphMutation } from '@/services/sidecar/useGraphProvider';
import { useCreateFolder } from '@/utils/folder';
import { DriveItem } from '@microsoft/microsoft-graph-types';
import { useVariable } from '@softwareimaging/backstage';
import { drive } from '../../../../sidecar/lists/drive';

export const useCreateMspMediaFolder = () => {
  const mspParentFolderId = useVariable<Variables>('mspsFolderId');
  if (!mspParentFolderId) throw new Error('Missing msp parent folder id');

  const { client } = useGraph();
  const driveId = useVariable<Variables>('graphDriveId');

  const lists = useLists();
  const createFolder = useCreateFolder(mspParentFolderId);

  return useGraphMutation(async ({ name, msp }: { name: string; msp: string }) => {
    const createFolderResult = await createFolder.mutateAsync({ name });

    const item = await client
      .api<DriveItem>(`/drives/${driveId}/items/${createFolderResult.id}`)
      .expand(['listItem'])
      .select(['id', 'name', 'folder', 'listItem'])
      .get();

    const props = {
      msp
    };

    const listItemId = item.listItem?.id;

    if (!listItemId) throw new Error('Missing list item id');

    const query = lists.update(drive).set(props).where(listItemId);
    await query.execute();
  });
};
